import { render, staticRenderFns } from "./modalViewPostDetails.vue?vue&type=template&id=a3411488&scoped=true&"
import script from "./modalViewPostDetails.vue?vue&type=script&lang=js&"
export * from "./modalViewPostDetails.vue?vue&type=script&lang=js&"
import style0 from "./modalViewPostDetails.vue?vue&type=style&index=0&id=a3411488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3411488",
  null
  
)

export default component.exports